<template>
  <div class="page-account-view amenity-page-wrapper">
    <header-back></header-back>

    <!-- Header con datos de la reserva -->
    <section class="bar theme-blue">
      <div v-if="booking.name" class="container">
        <div class="bar-img">
          <img :src="getTypeImage(booking)" />
        </div>
        <h3 class="bar-firm-name">{{ booking.name }}</h3>
        <h4 class="amenity-title" style="text-align: center; margin-bottom: 1.5rem">
          {{ booking.functional_unit.location }}
        </h4>
        <h5 class="bar-tagline">{{ booking.type }} &mdash;</h5>
      </div>
    </section>

    <!-- Contenido -->
    <div class="container amenity bar-details">
      <div class="card border-box">
        <img :src="booking.image" class="card-img-top" />
        <span
            :style="{ backgroundColor: booking.color }"
            style="color: #f2f2f2; text-align: center; width: 100%"
        >
          {{ booking.booking_status }}
        </span>

        <div class="card-body">
          <!-- Lista invitados -->
          <div class="container mt-4">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h5>
                Lista de Invitados
                <small class="text-muted d-block">
                  Hasta {{ booking.max_uf_booking_invites }} invitados
                </small>
              </h5>
              <button class="btn btn-primary"  :disabled="guestList.length >= booking.max_uf_booking_invites" @click="showModal = true">Agregar</button>
            </div>

            <table class="table table-bordered">
              <thead>
              <tr>
                <th>Nombre</th>
                <th>Tipo Doc</th>
                <th>Número</th>
                <th style="width: 50px;">&nbsp;</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(guest, index) in guestList" :key="index">
                <td>{{ guest.full_name }}</td>
                <td>{{ guest.identification_type == 1 ? 'DNI' : 'PASAPORTE' }}</td>
                <td>{{ guest.identification_number }}</td>
                <td>
                  <img
                      src="@/assets/img/icons/trash-delete-bin.svg"
                      class="icon"
                      style="vertical-align: top; cursor: pointer"
                      alt="Eliminar"
                      @click="removeGuest(index)"
                  />
                </td>
              </tr>
              <tr v-if="guestList.length === 0">
                <td colspan="4" class="text-center">No hay invitados aún</td>
              </tr>
              </tbody>
            </table>

            <!-- Modal agregar -->
            <div v-if="showModal" class="modal-backdrop">
              <div class="modal-container">
                <h5>Nuevo Invitado</h5>
                <form @submit.prevent="addGuest" style="margin-top:10px !important">
                  <div>
                    <label>Nombre</label>
                    <input v-model="newGuest.nombre" class="form-control" required />
                  </div>
                  <div>
                    <label>Tipo Documento</label>
                    <select v-model="newGuest.tipoDoc" class="form-control" required>
                      <option value="DNI">DNI</option>
                      <option value="Pasaporte">Pasaporte</option>
                    </select>
                  </div>
                  <div class="mb-4">
                    <label>Número</label>
                    <input v-model="newGuest.numero" class="form-control" required />
                  </div>
                  <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-outline-primary me-2" @click="showModal = false">
                      Cancelar
                    </button>
                    <button type="submit" class="btn btn-primary ml-3" :disabled="!isFormValid">
                      Guardar
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <!-- Modal confirmar eliminación -->
            <div v-if="showConfirmModal" class="modal-backdrop">
              <div class="modal-container">
                <h5>Confirmar eliminación</h5>
                <p>
                  ¿Estás seguro que deseas eliminar a
                  <b>{{ guestToDelete.full_name || guestToDelete.nombre }}</b>?
                </p>
                <div class="d-flex justify-content-end">
                  <button class="btn btn-outline-primary me-2" @click="cancelDelete">
                    Cancelar
                  </button>
                  <button class="btn btn-primary ml-3" @click="confirmDelete">
                    Eliminar
                  </button>
                </div>
              </div>
            </div>

            <!-- Modal error -->
            <div v-if="showErrorModal" class="modal-backdrop">
              <div class="modal-container">
                <h5>Error</h5>
                <p>{{ errorMessage }}</p>
                <div class="d-flex justify-content-end">
                  <button class="btn btn-primary" @click="showErrorModal = false">Cerrar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> <!-- card -->
    </div> <!-- container -->
  </div>
</template>

<script>
import HeaderBack from '@/components/Layouts/HeaderBack';

export default {
  name: 'BookingGuests',
  components: { HeaderBack },
  props: ['booking'],
  data() {
    return {
      isLoading: true,
      guestList: [],
      showModal: false,
      newGuest: { nombre: '', tipoDoc: 'DNI', numero: '' },
      showErrorModal: false,
      errorMessage: '',
      showConfirmModal: false,
      guestToDelete: null,
      guestIndexToDelete: null,
    };
  },
  mounted() {
    console.log('cap:', this.is_capacitor);
    if (!this.booking) {
      this.$router.push({ name: 'listado-reservas' });
    }
  },
  computed: {
    isFormValid() {
      return (
          this.newGuest.nombre.trim() !== ''
          && this.newGuest.tipoDoc.trim() !== ''
          && this.newGuest.numero.trim() !== ''
      );
    },
  },
  methods: {
    async addGuest() {
      // Construyo un array con los invitados actuales + el nuevo
      const updatedGuests = [
        ...this.guestList.map(g => ({
          full_name: g.full_name || g.nombre,
          identification_type: g.identification_type || (g.tipoDoc === 'DNI' ? '1' : '2'),
          identification_number: g.identification_number || g.numero,
          booking_id: this.booking.booking_id,
        })),
        {
          full_name: this.newGuest.nombre,
          identification_type: this.newGuest.tipoDoc === 'DNI' ? '1' : '2',
          identification_number: this.newGuest.numero,
          booking_id: this.booking.booking_id,
        },
      ];

      try {
        await this.$store.dispatch('updateReservationGuests', {
          ownersAssociationId: this.$store.getters.ownersAssociation.id,
          bookingId: this.booking.booking_id,
          data: updatedGuests,
        });

        this.guestList = await this.$store.dispatch('fetchGuestList', {
          ownersAssociationId: this.$store.getters.ownersAssociation.id,
          bookingId: this.booking.booking_id,
        });

        this.newGuest = { nombre: '', tipoDoc: 'DNI', numero: '' };
        this.showModal = false;
      } catch (err) {
        console.error(err);
        this.errorMessage = 'Ocurrió un error al guardar el invitado. Intenta de nuevo.';
        this.showErrorModal = true;
      }
    },
    removeGuest(index) {
      this.guestToDelete = this.guestList[index];
      this.guestIndexToDelete = index;
      this.showConfirmModal = true;
    },

    cancelDelete() {
      this.showConfirmModal = false;
      this.guestToDelete = null;
      this.guestIndexToDelete = null;
    },

    async confirmDelete() {
      try {
        const updatedGuests = this.guestList
            .filter((_, i) => i !== this.guestIndexToDelete)
            .map(g => ({
              full_name: g.full_name || g.nombre,
              identification_type: g.identification_type || (g.tipoDoc === 'DNI' ? '1' : '2'),
              identification_number: g.identification_number || g.numero,
              booking_id: this.booking.booking_id,
            }));

        await this.$store.dispatch('updateReservationGuests', {
          ownersAssociationId: this.$store.getters.ownersAssociation.id,
          bookingId: this.booking.booking_id,
          data: updatedGuests,
        });

        this.guestList = await this.$store.dispatch('fetchGuestList', {
          ownersAssociationId: this.$store.getters.ownersAssociation.id,
          bookingId: this.booking.booking_id,
        });

        this.showConfirmModal = false;
        this.guestToDelete = null;
        this.guestIndexToDelete = null;
      } catch (err) {
        console.error(err);
        this.errorMessage = 'Ocurrió un error al eliminar el invitado. Intenta de nuevo.';
        this.showErrorModal = true;
        this.showConfirmModal = false;
      }
    },
  },
  async created() {
    try {
      this.isLoading = true;
      this.guestList = await this.$store.dispatch('fetchGuestList', {
        ownersAssociationId: this.$store.getters.ownersAssociation.id,
        bookingId: this.booking.booking_id,
      });
    } catch (err) {
      console.error(err);
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;

  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
}
</style>
